/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState } from 'react';
import { ethers, BigNumber } from 'ethers';
import reBurnProtocol from '../artifacts/contracts/reBurnProtocol.sol/reBurnProtocol.json'
import ECRDummy from '../artifacts/contracts/ECRDummy.sol/ECRDummy.json'

import { useOutletContext } from "react-router-dom";
import CreateToken from '../CreateToken.js';

export default function Create() {
  const [web3, seedAddress, accounts, myTokens, setMyTokens] = useOutletContext();

    const [info, setInfo] = useState({
        fee: null,
        percentageFee: "5 (loading...)", //%
        balance: "unknown (loading...)",
        reward: null,
        isLoading: false
    })

    function bumpState(newStateChunk) {
        setInfo(prev => {return {
                ...prev,
                ...newStateChunk
        }});
    }

    async function loadFeeInfo() {
        const protocol = new ethers.Contract(seedAddress, reBurnProtocol.abi, web3)
        try{
            const rBPFee = await protocol.fee();
            const ownershipDenominator = await protocol.ownershipDenominator();
            const rawBalance = await protocol.balanceOf(accounts[0]);
            const shareFee = BigNumber.from(100).div(ownershipDenominator);
            const tokenFee = BigNumber.from(rBPFee).div(BigNumber.from(10).pow(18));
            const balanceDisplay = BigNumber.from(rawBalance).div(BigNumber.from(10).pow(18));

            const rewardTokenAddress = await protocol.rewardToken();
            const rewardAmount = await protocol.rewardAmount();

            let reward;

            if (rewardAmount && rewardTokenAddress) {
                const rewardContract = new ethers.Contract(rewardTokenAddress, ECRDummy.abi, web3)
                const rewardSymbol = await rewardContract.symbol();
                const rewardDecimals = await rewardContract.decimals();
                reward = BigNumber.from(rewardAmount).div(BigNumber.from(10).pow(rewardDecimals)).toString() + " " + rewardSymbol;
                bumpState({ fee: tokenFee.toString(), percentageFee: shareFee.toString(), balance: balanceDisplay.toString(), reward: reward });
            } else {
                bumpState({ fee: tokenFee.toString(), percentageFee: shareFee.toString(), balance: balanceDisplay.toString() });
            }
        } catch (e) {
            console.log(e);
        }
  }

  if (!info.isLoading) {
    bumpState({isLoading: true});
    loadFeeInfo();
  }

  return (
    <>
    <h2>Create my own token</h2>
      <div className="lead">
      To create your own token:
      <ul>
      {(info.reward) &&
          <li>
          you will be <b>rewarded</b> with <b>{info.reward}</b> and
          </li>
      }
      {(info.fee) ?
        ((info.fee !== "0") ?
          <li>
          the protocol will burn <b>{info.fee} rBP</b>. Your balance is <i>{info.balance}</i> (<a className="link-primary" href={"https://pancakeswap.finance/swap?inputCurrency=" + seedAddress}>See 🥞PancakeSwap</a>)
          </li>
          :
          <li>
          there is <b>no</b> extra fee
          </li>
        )
        :
        ""
      }
      <li>
      the protocol will get <b>{info.percentageFee}%</b> of the <b>initial</b> amount.
      Subsequent mints will go entirely into <b>your</b> treasury.
      </li>
      </ul>
      </div>

      <div className="card">
          <div className="card-header">
              Create token
          </div>
          <div className=" m-1 p-3">
      <CreateToken web3={web3} seedAddress={seedAddress} accounts={accounts} myTokens={myTokens} setMyTokens={setMyTokens} />
        </div>
      </div>
    </>
  );
}